import { Progress } from '@backstage/core-components';
import { FeedbackTable } from './FeedbackTable';
import {
  DevHubCard,
  DevHubGrid,
  DevHubPaper,
  DevHubLink,
  DevHubTypography,
} from '@devxdiscover/devhub-ui';
import { useQuery } from '@apollo/client';
import { FeedbackItems, GetApplicationFeedbackQuery } from './feedbackTypes';
import { useAppId } from '../../../contexts/SystemContext';
import ExportFeedback from './ExportFeedback/ExportFeedBack';

/**
 * FeedbackContent
 */
export const FeedbackContent = () => {
  const appId = useAppId();
  const { loading, data: feedback } = useQuery<FeedbackItems>(
    GetApplicationFeedbackQuery,
    {
      errorPolicy: 'all',
      variables: {
        applicationId: Number(appId),
      },
    },
  );

  if (loading) return <Progress />;

  // Pre-sort feedback by timestamp descending (newest first)
  const sortedFeedback =
    feedback?.resources?.application?.feedback
      ?.slice()
      .sort(
        (a, b) =>
          new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime(),
      ) ?? [];

  return (
    <DevHubGrid container>
      {sortedFeedback.length > 0 && (
        <DevHubGrid item xs={12}>
          <DevHubPaper>
            <ExportFeedback feedback={sortedFeedback} />
            <FeedbackTable feedback={sortedFeedback} />
          </DevHubPaper>
        </DevHubGrid>
      )}
      <DevHubGrid item xs={12}>
        <DevHubCard
          density="cozy"
          title="Need more feedback?"
          body={
            <DevHubTypography fontSize="large">
              For more details, please visit the{' '}
              <DevHubLink
                href="/community/default/component/devhub-community/feedback/feedback-as-a-service-integration/"
                target="_blank"
              >
                Feedback as a Service Integration Guide
              </DevHubLink>
              .
            </DevHubTypography>
          }
        />
      </DevHubGrid>
    </DevHubGrid>
  );
};
